import {
  FaCopy,
  FaEnvelope,
  FaFileCode,
  FaFileExport,
  FaFilePdf,
  FaPrint,
} from "react-icons/fa";
import { toast } from "react-toastify";

const downloadFile = (content, fileName, mimeType) => {
  const blob = new Blob([content], {
    type: mimeType,
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();
  link.remove();

  URL.revokeObjectURL(url);
};

const escapeXml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");

export default function InvoiceActions({
  invoice,
  summary,
  invoiceRef,
  onClose,
}) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(invoice.number);

      toast.success("Número de factura copiado.");
    } catch {
      toast.error("No fue posible copiar el número de factura.");
    }
  };

  const handlePrint = () => {
    if (!invoiceRef?.current) {
      toast.error("No fue posible preparar la factura para impresión.");
      return;
    }

    window.print();
  };

  const handlePdf = () => {
    toast.info(
      "En la ventana de impresión selecciona “Guardar como PDF”."
    );

    window.print();
  };

  const handleJson = () => {
    const data = {
      invoice,
      summary,
    };

    downloadFile(
      JSON.stringify(data, null, 2),
      `factura_${invoice.number}.json`,
      "application/json"
    );

    toast.success("Archivo JSON descargado.");
  };

  const handleXml = () => {
    const itemsXml = (invoice.items || [])
      .map(
        (item) => `
          <item>
            <sku>${escapeXml(item.sku)}</sku>
            <producto>${escapeXml(item.product_name)}</producto>
            <cantidad>${escapeXml(item.quantity)}</cantidad>
            <precio_unitario>${escapeXml(item.unit_price)}</precio_unitario>
            <subtotal>${escapeXml(item.subtotal)}</subtotal>
          </item>
        `
      )
      .join("");

    const xml = `<?xml version="1.0" encoding="UTF-8"?>
<factura>
  <numero>${escapeXml(invoice.number)}</numero>
  <estado>${escapeXml(invoice.status)}</estado>
  <cliente>${escapeXml(invoice.customer_name)}</cliente>
  <fecha_emision>${escapeXml(invoice.issue_date)}</fecha_emision>
  <fecha_vencimiento>${escapeXml(invoice.due_date)}</fecha_vencimiento>
  <subtotal>${escapeXml(invoice.subtotal)}</subtotal>
  <impuesto>${escapeXml(invoice.tax)}</impuesto>
  <descuento>${escapeXml(invoice.discount)}</descuento>
  <total>${escapeXml(invoice.total)}</total>
  <items>${itemsXml}</items>
</factura>`;

    downloadFile(
      xml,
      `factura_${invoice.number}.xml`,
      "application/xml"
    );

    toast.success("Archivo XML descargado.");
  };

  const handleEmail = () => {
    const subject = encodeURIComponent(
      `Factura ${invoice.number}`
    );

    const body = encodeURIComponent(
      `Hola,\n\nCompartimos la factura ${invoice.number} por un valor de ${Number(
        invoice.total || 0
      ).toLocaleString("es-CO")}.\n\nSaludos.`
    );

    window.location.href = `mailto:${invoice.customer_email || ""}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="invoice-actions">
      <div className="invoice-actions-title">
        <span>Factura</span>
        <strong>{invoice.number}</strong>
      </div>

      <div className="invoice-actions-buttons">
        <button
          type="button"
          className="invoice-action-button outline"
          onClick={handleCopy}
        >
          <FaCopy />
          Copiar N.º
        </button>

        <button
          type="button"
          className="invoice-action-button outline"
          onClick={handleJson}
        >
          <FaFileExport />
          JSON
        </button>

        <button
          type="button"
          className="invoice-action-button outline"
          onClick={handleXml}
        >
          <FaFileCode />
          XML
        </button>

        <button
          type="button"
          className="invoice-action-button email"
          onClick={handleEmail}
        >
          <FaEnvelope />
          Correo
        </button>

        <button
          type="button"
          className="invoice-action-button pdf"
          onClick={handlePdf}
        >
          <FaFilePdf />
          PDF
        </button>

        <button
          type="button"
          className="invoice-action-button print"
          onClick={handlePrint}
        >
          <FaPrint />
          Imprimir
        </button>
      </div>
    </div>
  );
}